import { X, Sun, CloudSun, Sunset, Moon, AlertTriangle } from "lucide-react";

const MYT = "Asia/Kuala_Lumpur";

/** Sapaan ikut waktu Malaysia: pagi / tengah hari / petang / malam. */
export function greetingFor(name, role) {
  const h = Number(new Intl.DateTimeFormat("en-GB", { hour: "numeric", hour12: false, timeZone: MYT }).format(new Date())) % 24;
  const first = (name || "").split(" ")[0] || "";
  const tips = {
    superadmin: "Nak saya ringkaskan operasi semua cawangan?",
    branch_manager: "Nak saya semak status cawangan anda?",
    admin: "Nak saya semak guru & menu hari ini?",
    guru: "Jom semak log harian & aktiviti kelas anda.",
    ibu_bapa: "Ingin tahu aktiviti anak anda hari ini?",
  };
  let g, Icon, tone;
  if (h >= 5 && h < 12) { g = "Selamat pagi"; Icon = Sun; tone = "text-amber-500"; }
  else if (h >= 12 && h < 14) { g = "Selamat tengah hari"; Icon = CloudSun; tone = "text-orange-500"; }
  else if (h >= 14 && h < 19) { g = "Selamat petang"; Icon = Sunset; tone = "text-rose-500"; }
  else { g = "Selamat malam"; Icon = Moon; tone = "text-indigo-500"; }
  return { title: `${g}${first ? `, ${first}` : ""}!`, text: `Saya Mimi Junior. ${tips[role] || tips.ibu_bapa}`, Icon, tone, period: g };
}

/** Gelembung percakapan Mickey di sebelah butang AI. */
export default function MickeySpeech({ pos, size, kind = "greet", title, text, Icon, tone, onClick, onClose }) {
  const leftSide = pos.x + size / 2 < window.innerWidth / 2;
  const style = {
    top: Math.max(8, pos.y + size / 2 - 38),
    ...(leftSide ? { left: pos.x + size + 12 } : { right: window.innerWidth - pos.x + 12 }),
  };
  const sad = kind === "sad";
  const Ico = sad ? AlertTriangle : Icon;
  return (
    <div className="fixed z-[9999] mk-speech" style={style} data-testid={sad ? "mickey-speech-sad" : "mickey-speech-greet"}>
      <div role="button" tabIndex={0} onClick={onClick} onKeyDown={(e) => e.key === "Enter" && onClick?.()}
        className={`relative max-w-[250px] rounded-2xl px-3 py-2 pr-7 shadow-xl border cursor-pointer select-none transition-transform duration-200 hover:-translate-y-0.5 ${sad ? "bg-rose-50 border-rose-200" : "bg-white border-pink-100"}`}>
        <div className={`flex items-center gap-1.5 text-[13px] font-extrabold ${sad ? "text-rose-700" : "text-slate-800"}`}>
          {Ico && <Ico className={`h-4 w-4 shrink-0 ${sad ? "text-rose-500" : tone}`} />}
          <span>{title}</span>
        </div>
        <div className={`text-[12px] leading-snug mt-0.5 ${sad ? "text-rose-600" : "text-slate-500"}`}>{text}</div>
        <button onClick={(e) => { e.stopPropagation(); onClose?.(); }} aria-label="Tutup" data-testid="mickey-speech-close"
          className="absolute top-1.5 right-1.5 h-5 w-5 rounded-full grid place-items-center text-slate-400 hover:text-slate-600 hover:bg-slate-100">
          <X className="h-3.5 w-3.5" />
        </button>
        <span className={`absolute top-8 h-3 w-3 rotate-45 border ${sad ? "bg-rose-50 border-rose-200" : "bg-white border-pink-100"} ${leftSide ? "-left-1.5 border-r-0 border-t-0" : "-right-1.5 border-l-0 border-b-0"}`} />
      </div>
    </div>
  );
}
